import React from 'react';

import { useTranslation } from 'react-i18next';
import { Container, Content } from '../../components/home/v2/styledComponents';
import Layout from '../../layouts/index';
import MenuBar from '../../components/home/MenuBar';
import FootNote from '../../components/LandingPage/FootNote';
import Footer from '../../components/home/v3/Footer';
import CoutureServices from '../../components/home/OurServices/CoutureServices';
import { getFAQ } from './LandingAds2';

import withOrderContext from '../../withOrderContext';

const LandingMainAlterationClothesProps = {
  slug: 'MainAlterationClothesPage',
  path: '/retouche-vetement/',
  preFilledSteps: {
    selectedCategory: 'clothes',
  },
  footNote: {
    title: 'En savoir plus',
    // eslint-disable-next-line max-len
    paragraph: 'Retoucher ses vêtements était courant à l’époque de nos grands-parents, on savait coudre soi-même ou on avait toujours autour de soi un couturier de famille. Nous n’allons pas vous regarder de travers si vous nous dites que vous ne savez pas retoucher vos vêtements, même les choses les plus simples. ;) \n\nTilli vous propose un service de retouches de vêtements à domicile vous permettant de retoucher absolument tous vos vêtements. Que vos vêtements soient neufs ou anciens, nos couturiers sont expérimentés pour retoucher aussi bien des retouches basiques que complexes. Vous trouverez dans notre estimation de devis la distinction entre vêtements simples ou habillés. Les retouches de vêtements sur un pantalon de tailleur ou sur un chino n’engagent pas le même travail de nos couturiers. Si vous avez un doute lors de l’estimation de votre ou de vos retouches, vous pouvez passer cette étape, le couturier se charge lors du RDV de vous expliquer les tarifs et de lui même via son application mettre à jour votre commande. Tilli peut aussi <link>retoucher vos rideaux et voilages<link>.',
    links: ['/retouche-rideaux/'],
    breadcrumbIntro: {
      // eslint-disable-next-line max-len
      paragraph: 'Votre service de <link>retouches de vêtements disponible à Paris<link>, <link>Lyon<link>, <link>Bordeaux<link>, <link>Marseille<link>, <link>Toulouse<link>, <link>Nantes<link>, <link>Rennes<link>, <link>Lille<link>, <link>Nice<link>, <link>Montpellier<link> et dans une quinzaine d’autres villes en France ou à <link>Bruxelles<link>.',
      links: ['/retouche-vetement/paris/', '/retouche-vetement/lyon/', '/retouche-vetement/bordeaux/', '/retouche-vetement/marseille/',
        '/retouche-vetement/toulouse/', '/retouche-vetement/nantes/', '/retouche-vetement/rennes/', '/retouche-vetement/lille/', '/retouche-vetement/nice/',
        '/retouche-vetement/montpellier/', '/retouche-vetement/bruxelles/'],
    },
  },
  breadcrumb: [
    { name: 'Accueil', item: '/' },
    { name: 'Retouche Vêtement', item: '/retouche-vetement/' },
  ],
};

function LandingMainAlterationClothes() {
  const { t } = useTranslation();
  const {
    slug, footNote, breadcrumb,
  } = LandingMainAlterationClothesProps;

  const faqQuestions = [...getFAQ(t, '', false)].map((faqQuestion) => {
    faqQuestion.answers = faqQuestion.answers || [faqQuestion.answer];
    return faqQuestion;
  });

  return (
    <Layout routeSlug={slug}>
      <Container>
        <Content full hasNoBanner>
          <MenuBar />
          <CoutureServices
            faqQuestions={faqQuestions}
            preSelectedRange="dressing"
          />
          <FootNote
            title={footNote.title}
            paragraph={footNote.paragraph}
            breadcrumbIntro={footNote.breadcrumbIntro.paragraph}
            breadcrumbIntroLinks={footNote.breadcrumbIntro.links}
            links={footNote.links}
            itemListElement={breadcrumb}
            isLeatherGoods
          />
          <Footer />
        </Content>
      </Container>
    </Layout>
  );
}

export default withOrderContext(LandingMainAlterationClothes);
